import React, { useCallback } from "react";

import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";
import { ShapeItemType } from "@mapmycustomers/shared/types/map/PinLegend";

import { ShapeDropdown } from "@app/component/input/shape";

import OptionValueEditorProps from "../types/OptionValueEditorProps";

import BaseOptionItem from "./BaseOptionItem";

interface Props<T> extends OptionValueEditorProps<T> {}

const ShapeOptionItem = <T extends ShapeItemType>({ label, onChange, value }: Props<T>) => {
  const handleShapeChange = useCallback(
    (shape: MarkerShape) => {
      onChange?.({ ...value, shape });
    },
    [onChange, value]
  );

  return (
    <BaseOptionItem label={label}>
      <ShapeDropdown onChange={handleShapeChange} value={value.shape} />
    </BaseOptionItem>
  );
};

export default ShapeOptionItem;
